import React from 'react';
import { FormattedMessage } from 'react-intl';
import Moment from 'react-moment';
import { ReactComponent as FileIcon } from '../../../assets/img/svg/pdf.svg';
import { LS_ACCESS_TOKEN } from '../../../constants';
import dlt from '../../../utils/default-lang';
import { BodyText, SmallText } from '../../typography';
import LoanDocumentsSC from './loan-documents.styled';

const onDocumentClick = (docLink) => {
  window.open(
    `${process.env.REACT_APP_WISHMAKER_API_URI}${
      process.env.REACT_APP_DOC_SLUG
    }/${docLink}?token=${localStorage.getItem(LS_ACCESS_TOKEN)}`
  );
};

const LoanDocuments = ({ documents }) => {
  return (
    <LoanDocumentsSC>
      <div className="body-wrapper">
        <div className="headline-data-wrap">
          <BodyText className="bolder">
            <FormattedMessage
              id="investor_loan_detail_documents_headline"
              defaultMessage={dlt['investor_loan_detail_documents_headline']}
            />
          </BodyText>
        </div>
        <div className="body-data-wrap">
          <div className="body-data-wrap--item">
            <div className="documents-wrap">
              {documents.map((doc) => (
                <div
                  className="document-item-wrap"
                  onClick={() => onDocumentClick(doc.url)}
                  key={doc.id}
                >
                  <span className="document-icon">
                    <FileIcon />
                  </span>
                  <div className="document-name">
                    <div>{doc.name}</div>
                    <SmallText className="black-transparent">
                      <Moment format="DD. MMMM YYYY HH:mm">{doc.created_at}</Moment>
                    </SmallText>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </LoanDocumentsSC>
  );
};

export default LoanDocuments;
